import React, { CSSProperties, useEffect, useState, } from 'react';
import { Project } from '../Models/Project';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { useAppSelector, useAppDispatch } from '../Core/hooks';
// addCard, saveCard, copyCard, addList, saveList, saveListObject,
import { getProject, minimizeList, 
    setLists,  setCards,
    setProjectStatus,
 } from '../Store/Project';
 import { getRoadmap , getRoadmapCards} from '../Store/Roadmap';
 import { getSettings } from '../Store/Settings';

import { FaChevronCircleLeft, FaChevronCircleRight, FaCopy, FaEllipsisV, FaUserCircle  } from "react-icons/fa";
import { ProjectCard } from'../Models/ProjectCard';
import { Label } from '../Models/Label';

//import CardContext from '../../Components/CardContext';
//import { ContextMenu } from '../Models/ContextMenu';
import { BsThreeDots } from "react-icons/bs";
import { FiMinimize2 } from "react-icons/fi";
import { IoTrashOutline } from "react-icons/io5";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { MdLabel} from "react-icons/md";

import { ListContextMenuParam } from '../Models/Requests/ListContexMenuParam';
import ListContextMenu from '../Modals/ListContextMenu';
import { CardContextParam } from '../Models/Requests/CardContextParam';
import CardContextMenu from '../Modals/CardContext';
import { LabelContextMenuParam } from '../Models/Requests/LabelContextMenuParam';
import LabelContextMenu from '../Modals/LabelContextMenu';
import { openSocket } from '../Helpers/openSocket';
import Avatar from "../Components/Avatar";
import { ProjectList } from '../Models/ProjectList';
import PopupContextMenu from '../Modals/PopupContext';
import { PopupContextParam } from '../Models/Requests/PopupContextParam';
import ChangeListStatusContextMenu from '../Modals/ChangeListStatusContextMenu';
import { ChangeListContextMenuParams } from '../Models/Requests/ChangeListContextMenuParams';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { GiStopwatch } from "react-icons/gi";

interface Props {
    project: Project;
}

function WorkBoard(props: Props) {

    const dispatch = useAppDispatch();
    const projectState = useAppSelector(getProject);
    const roadmapState = useAppSelector(getRoadmap);
    const settingsState = useAppSelector(getSettings);
    const [newList, setNewList] = useState("");
    const [newCardTitles, setNewCardTitles] = useState<Array<string>>([]);
    const [listNames, setListNames] = useState<Array<string>>([]);
    const [listNamesInEditMode, setListNamesInEditMode] = useState<Array<boolean>>([]);
    const [showAddListField, setShowAddListField] = useState<Array<boolean>>([]);
    const [hideLabelText, setHidelabelText] = useState<boolean>(false);
    const [listContextMenuParams, setListContextMenuParams] = useState<ListContextMenuParam>();
    const [changeListContextMenuParams, setChangeListContextMenuParams] = useState<ChangeListContextMenuParams>();
    const [cardContextParams, setCardContextParams] = useState<CardContextParam>();
    const [labelContextMenuParams, setLabelContextMenuParams] = useState<LabelContextMenuParam>();
    const [popupParams, setPopupParams] = useState<PopupContextParam>();
    //const [triggerEditMode, setTriggerEditMode] = useState(false);

    useEffect(() => {
        let project = projectState.projects.find(p => p.loaded);
        if (project) {
            setHidelabelText(project.minimizedLabels);
        }
    },[]);

    useEffect(() => {
       if (props.project) {
            setCardContextParams({ projectId: props.project._id, cardId: "" });
            setListContextMenuParams({ projectId: props.project._id, listId: "" });
            setChangeListContextMenuParams({ listId: "" });
        }
    }, [projectState.projects])

    useEffect(() => {
        if (projectState.status === "workChanged") {
            dispatch(setProjectStatus("idle"));
            dispatch(getRoadmapCards(props.project.roadmapId));
        }
        if (projectState.status === "listCopied") {
            /* If list was copied, put name into edit mode once lists array is updated */
            const mostRecentList = projectState.lists.reduce((latest, current) => {
                return new Date(current.created) > new Date(latest.created) ? current : latest;
            });
            //console.log(mostRecentList);
            if (mostRecentList) {  
                let tempListNamesInEditMode = [...listNamesInEditMode];
                tempListNamesInEditMode[mostRecentList.index] = !tempListNamesInEditMode[mostRecentList.index];
                setListNamesInEditMode(tempListNamesInEditMode);
            }
            dispatch(setProjectStatus("idle"));       
        }
    }, [projectState.status]);

    useEffect(() => {

        setCardContextParams(undefined); /* close card window on project refresh */
        
        if (projectState.lists.length > 0) {
            
            let tempListNames = [...listNames];
            projectState.lists.forEach((l, i) => {
                tempListNames[i] = l.name;
            });

            setListNames(tempListNames);

            if (projectState.status === "listAdded") {
                /* hide all add list inputs */
                setShowAddListField([]);
            }
        }
    },[projectState.lists]);

    const handleNewListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewList(e.target.value);
    }

    const createNewList = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (['Enter'].indexOf(e.key) !== -1 && newList !== "") {
            e.preventDefault();
            e.stopPropagation();
            if (props.project) {
                /*
                dispatch(addList({ 
                    projectId: props.project._id,
                    name: newList,
                    index: index
                }));
                */
                let socket = openSocket(dispatch, settingsState);
                if (socket) {
                    socket.emit("createList", { 
                        projectId: props.project._id,
                        name: newList,
                        index: index
                    });
                }
                setNewList("");
            }
        }
    }

    const handleNewCardTitleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let cardTitles = [...newCardTitles];
        cardTitles[index] = e.target.value;
        setNewCardTitles(cardTitles);
    }

    const createNewCard = (e: React.KeyboardEvent<HTMLInputElement> | React.FocusEvent<HTMLInputElement>, index: number, listId: string) => {
        
        let cardTitles = [...newCardTitles];
        if (cardTitles[index] !== "") {
            if ((e.type === "keydown" && ['Enter'].indexOf((e as React.KeyboardEvent<HTMLInputElement>).key) !== -1) ||
                e.type === "blur") {

                e.preventDefault();
                e.stopPropagation();

                let socket = openSocket(dispatch, settingsState);
                if (socket) {
                    socket.emit("createCard", { 
                        title: newCardTitles[index], 
                        listId: listId
                    });
                }

                cardTitles[index] = "";
                setNewCardTitles(cardTitles);

                /*
                dispatch(addCard({ title: newCardTitles[index], listId: listId}));           
                cardTitles[index] = "";
                setNewCardTitles(cardTitles);
                */
            }
        }
    }

    const handleListNameChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        
        let tempListNames = [...listNames];
        tempListNames[index] = e.target.value;
        setListNames(tempListNames);
        
    }

    const updateListName = (e: React.KeyboardEvent<HTMLInputElement>, index: number, listId: string) => {
        
        let tempListNames = [...listNames];
        if (['Enter'].indexOf(e.key) !== -1 && tempListNames[index] !== "") {

            e.preventDefault();
            e.stopPropagation();

            let tempListNamesInEditMode = [...listNamesInEditMode];
            tempListNamesInEditMode[index] = false;
 
            setListNamesInEditMode(tempListNamesInEditMode);
            //dispatch(saveList({ _id: listId, name: tempListNames[index] }));  
            let socket = openSocket(dispatch, settingsState);
            if (socket) {
                socket.emit("saveList", { 
                    id: listId, 
                    name: tempListNames[index]
                });
            }         
        }
    }

    const updateListNameOnBlur = (e: React.FocusEvent<HTMLInputElement>, index: number, listId: string) => {
        
        let tempListNames = [...listNames];
        e.preventDefault();
        let tempListNamesInEditMode = [...listNamesInEditMode];
        tempListNamesInEditMode[index] = false;
        setListNamesInEditMode(tempListNamesInEditMode);
        //dispatch(saveList({ _id: listId, name: tempListNames[index] }));
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("saveList", { 
                id: listId, 
                name: tempListNames[index]
            });
        }
    }

    const toggleEditListName = (index: number) => {
        let tempListNamesInEditMode = [...listNamesInEditMode];
        tempListNamesInEditMode[index] = !tempListNamesInEditMode[index];
        setListNamesInEditMode(tempListNamesInEditMode);
    }

    const toggleListContextMenu = (e: React.MouseEvent<HTMLAnchorElement>, listId: string) => {
        e.preventDefault();
        setListContextMenuParams({ projectId: project._id, listId: listId, event: e });  
    };

    const toggleCardContext = (e: React.MouseEvent<HTMLDivElement>, cardId: string) => {
        e.preventDefault();
        setCardContextParams({ projectId: project._id, cardId: cardId, event: e });   
    };

    const handleCopyCard = (e: React.MouseEvent<HTMLDivElement>, card: ProjectCard) => {
        e.preventDefault();
        e.stopPropagation();
        //dispatch(copyCard(card));
        let project = projectState.projects.find(p => p.loaded);
        if (project) {
            let socket = openSocket(dispatch, settingsState);
            if (socket) {
                socket.emit("copyCard", { 
                    projectId: project._id,
                    card: card,
                });
            }
        }
    }

    const handleCopyList = (e: React.MouseEvent<HTMLDivElement>, list: ProjectList) => {
        e.preventDefault();
        e.stopPropagation();
        
        let project = projectState.projects.find(p => p.loaded);
        if (project) {
            let socket = openSocket(dispatch, settingsState);
            if (socket) {
                socket.emit("copyList", { 
                    projectId: project._id,
                    list: list,
                });
            }
        }
    }

    const toggleAddListField = (e: React.MouseEvent<HTMLAnchorElement>, index: number) => {
        e.preventDefault();
        e.stopPropagation();
        let temp = [...showAddListField];
        temp[index] = !temp[index];
        setShowAddListField(temp);
    }

    const onDragEnd = (result: any) => {
        
        /* Observers cannot move cards around */
        if (props.project) {
            if (props.project.permission) {
                if (props.project.permission.toString() === "observer") {
                    return;
                }
            }
        }

        let cardId = result.draggableId;
        let newIndex = parseInt(result.destination.index);
        let oldIndex = parseInt(result.source.index);
        let newListId = result.destination.droppableId;
        let oldListId = result.source.droppableId;

        let cardsInOldList: Array<ProjectCard> = [];
        let cardsInNewList: Array<ProjectCard> = [];
        let cardsToUpdate: Array<ProjectCard> = [];

        let card = projectState.cards.find(c => c._id === cardId);
        let newList = projectState.lists.find(l => l._id === newListId);

        // Reshuffle the cards in the list the card is being dragged into
        cardsInNewList = projectState.cards.filter(c => c.listId === newListId).sort(({ index :a }, { index :b }) => a-b );
        if (card) {
            if (oldListId === newListId) {
                cardsInNewList.splice(oldIndex, 1);
            }
            cardsInNewList.splice(newIndex, 0, card);
            let sortedCardsInList = cardsInNewList.map((c, i) => {
                return {...c, index: i, listId: newListId, ...(oldListId !== newListId && c._id === cardId && newList) && { status: newList.status, statusChanged: new Date() } };
            });

            sortedCardsInList.forEach( c => {
                cardsToUpdate.push(c);
            }); 
        }

        if (oldListId !== newListId) {
            cardsInOldList = projectState.cards.filter(c => c.listId === oldListId).sort(({ index :a }, { index :b }) => a-b );
            if (card) {
                cardsInOldList.splice(oldIndex, 1);
                let sortedCardsInList = cardsInOldList.map((c, i) => {
                    return {...c, index: i };
                });
                sortedCardsInList.forEach( c => {
                    cardsToUpdate.push(c);
                });
            }
        }

        // Update frontend
        let cards = projectState.cards.map(card => {
            let cardUpdated = cardsToUpdate.find(c => c._id === card._id);
            if (cardUpdated) {
                return cardUpdated;
            }
            return card;
        })
        cards.sort(({ index :a }, { index :b }) => a-b );
        dispatch(setCards(cards)); // update frontend

        // update the backend
        /*
        cardsToUpdate.forEach(card => {
            dispatch(saveCard(card));
        });
        */
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            cardsToUpdate.forEach(card => {
                socket.emit("saveCard", { 
                    card: card
                });
            });
        }
              
    }

    const moveList = (id: string, adjustment: number) => {
        
        let listIdsToUpdate: Array<string> = [];
        let listIndex = projectState.lists.findIndex(l => l._id === id);
        
        if (listIndex !== -1) {
            let moveToIndex = listIndex + adjustment;
            let lists = projectState.lists.map((list, index) => {
                if(index === listIndex) {
                    listIdsToUpdate.push(list._id);
                    return { ...list, index: moveToIndex };
                } else if (index === moveToIndex) {
                    listIdsToUpdate.push(list._id);
                    return { ...list, index: listIndex };
                }
                return list;
            });

            lists.sort(({ index :a }, { index :b }) => a-b );
            dispatch(setLists(lists)); // update frontend
            lists.forEach(list => {
                let listNeedsUpdated = listIdsToUpdate.findIndex(l => l === list._id);
                if (listNeedsUpdated !== -1) {
                    //dispatch(saveListObject(list));
                    let socket = openSocket(dispatch, settingsState);
                    if (socket) {
                        socket.emit("saveListObject", { 
                            list: list
                        });
                    }
                }
            });
        }
    }

    const handleHideLabelText = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setHidelabelText(!hideLabelText);
        /* persist to backend */
        let project = projectState.projects.find(p => p.loaded);
        if (project) {
            let socket = openSocket(dispatch, settingsState);
            if (socket) {
                socket.emit("minimizeProjectLabels", { 
                    projectId: project._id,
                    minimizeLabels: !hideLabelText 
                });
            }
        }
    }

    const toggleLabelContextMenu = (e: React.MouseEvent<HTMLDivElement>, cardId: string) => {
        e.preventDefault();
        e.stopPropagation();
        setLabelContextMenuParams({ cardId: cardId, event: e });
    };

    const handleMinimizeList = (e: React.MouseEvent<HTMLAnchorElement>, id: string, minimize: boolean) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(minimizeList({ _id: id, minimize: minimize }));
    }

    const handleDeleteList = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        /* Show the delete confirmation window */
        setPopupParams({
            _id: id,
            event: e,
            buttonClass: "btnDelete",
            buttonText: "Delete",
            closeHandler: closeDeleteListPopup,
            buttonHandlerWithId: deleteListConfirmed,
            message: "This will delete the list and all its cards. There is no undo.",
            headingText: "Delete List",
            backButton: false
        });
    }

    const closeDeleteListPopup = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setPopupParams({
            _id: "",
            event: e,
            buttonClass: "",
            buttonText: "",
            closeHandler: closeDeleteListPopup,
            buttonHandlerWithId: deleteListConfirmed,
            message: "",
            headingText: "",
            backButton: false,
        });
    }

    const deleteListConfirmed = (e: React.MouseEvent<HTMLDivElement>, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        // delete backend
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("deleteList", { 
                id: id
            });
        }
        // delete on front end
        const lists: Array<ProjectList> = [...projectState.lists];
        const index = projectState.lists.findIndex(l => l._id === id);
        lists.splice(index, 1);
        dispatch(setLists(lists));
        closeDeleteListPopup(e);
    }

    const handleShowChangeListStatus = (e: React.MouseEvent<HTMLDivElement>, id: string) => {
        e.stopPropagation();
        e.preventDefault();
        setChangeListContextMenuParams({ listId: id, event: e });
    }

    const toggleWatch = (e: React.MouseEvent<HTMLDivElement>, cardId: string) => {
        e.preventDefault();
        e.stopPropagation();
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("logProjectCardWorkTime", { 
                cardId: cardId
            });
        }
    }

    //let project = projectState.projects.find(p => p.loaded);
    let project = props.project;
    let projectCardCount = 0;
    let projectLists = projectState.lists.filter(l => l.projectId === project._id);

    if (projectLists) {
        projectLists.forEach(l => {
            let listCards = projectState.cards.filter(c => c.listId === l._id);
            projectCardCount += listCards.length;
        });
    }

    let isObserver = true;
    if (project) {
        if (project.permission) {
            isObserver = (project.permission.toString() === "observer");
        }
    }

    //let category = roadmapState.categories.find(c => c._id === project.categoryId);
    //let listStyle: CSSProperties = (category) ? { backgroundColor : category.backgroundColor, color: category.fontColor } : {};
    //console.log("Project: " + props.project.id);
    //console.log("Project Lists: " + projectState.lists.length);
    let sortedLists = [...projectState.lists].sort(({ index :a }, { index :b }) => a-b );
    let lists = sortedLists.map((list, index) => {
        let listSetting = projectState.listSettings.find(ls => ls.listId === list._id);
        let minimized = (listSetting) ? listSetting.minimized : false;

        let placeholderDropText = (minimized) ? projectState.cards.filter(c => c.listId === list._id).length : "drop card here";
        
        let cards: Array<ProjectCard> = (settingsState.settings.searchText === "" || !settingsState.settings.searchText) ?
            projectState.cards.filter(c => c.listId === list._id) 
        : 
            projectState.cards.filter(c => c.listId === list._id && 
                (c.title.toLowerCase().includes(settingsState.settings.searchText.toLowerCase()) || 
                 c.description.toLowerCase().includes(settingsState.settings.searchText.toLowerCase())));

        // sort cards for other socket users in case re-ordered by this user
        cards.sort(({ index :a }, { index :b }) => a-b );

/*
        let cards: Array<Card> = (projectState.searchText === "") ?
                projectState.cards.filter(c => c.listId === list.id)
            :
                projectState.cards.filter(c => c.listId === list.id && 
                    (c.title.includes(projectState.searchText) || 
                     c.description.includes(projectState.searchText)
                    ));
*/
        let formattedCards = (minimized) ? [] : cards.map((c, index) => {

            let cardOwner = roadmapState.members.find(m => m.userId === c.ownerId && c.ownerId !== "");
            let labelsToCards = projectState.labelsToCards.filter(lc => lc.cardId === c._id);
            if (project && c.roadmapItem !== "") {
                labelsToCards.unshift({
                    _id: "",
                    labelId: "",
                    cardId: c._id,
                    created: new Date(),
                })
                /* used to be below 
                labelsToCards.unshift({
                    id: -1,
                    labelId: -1,
                    cardId: c.id,
                    created: new Date(),
                })*/
            }

            let workEntries = projectState.projectCardWorkLog.filter(e => e.cardId === c._id);
            let stopwatchColor = (workEntries.length % 2 === 0) ? "#a3a3a3" : "#d35400";

            let progress = (c.actualWork > c.estimatedWork) ? 100 : c.actualWork / c.estimatedWork * 100;

            if (c.status === "Done") {
                progress = 100;
            }

            let listsStatusPillBackgroundColor = "";
            if (list.status === "Open") {
                listsStatusPillBackgroundColor = "#2e86c1";
            } else if (list.status === "In Progress") {
                listsStatusPillBackgroundColor = "#e67e22";
            } else if (list.status === "Paused") {
                listsStatusPillBackgroundColor = "#f4d03f";
            } else if (list.status === "Done") {
                listsStatusPillBackgroundColor = "#138d75";
            } else if (list.status === "Canceled") {
                listsStatusPillBackgroundColor = "#2e4053";
            } else if (list.status === "Strategy") {
                listsStatusPillBackgroundColor = "#9b59b6";
            }

            let baseStyle: CSSProperties = {
                //backgroundColor: "#e5e7e9",
                backgroundColor: listsStatusPillBackgroundColor,
                opacity: .4,
                width: "100%", 
                height: "4px",
                borderRadius: "30px",
                marginBottom: "5px",
            }
            
            let progressStyle: CSSProperties = {
                width: progress + "%",
                backgroundColor: listsStatusPillBackgroundColor,
                height: "4px",
                borderRadius: "30px",
                position: "relative",
                top: "-9px",
                //marginBottom: "5px"
            }

            return (
                <Draggable key={c._id} draggableId={c._id.toString()} index={index}>
                    {(provided, snapshot) => (
                        <div
                            onClick={(e) => toggleCardContext(e, c._id)}
                            className="activeCard"
                            key={index}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                                ...(provided.draggableProps.style || {}),
                                ...(index > 0 ? { marginTop: "4px" } : {})
                              }}
                        >
                            {c.estimatedWork > 0 &&
                            <>
                                <div style={baseStyle}></div>
                                <div style={progressStyle}></div>
                            </>
                            }
                            <div className="cardNotHover">
                                {project?.permission?.toString() !== "observer" &&
                                <>
                                    <div className="copyCardIcon" onClick={e => handleCopyCard(e, c)}>
                                        <span style={{ position: "relative", top: "-4px" }}>
                                            <FaCopy size="10" color="gray" />
                                        </span> 
                                    </div>
                                    <div className="addCardLabelIcon" onClick={(e) => toggleLabelContextMenu(e, c._id)}>
                                        <span style={{ position: "relative", top: "-4px", right: "-1px" }}>
                                            <MdLabel size="10" color="gray" />
                                        </span>
                                   </div>
                                </>
                                }

                                {labelsToCards.map(lc => {
                                    let label: Label | undefined = undefined;
                                    if (lc._id === "") { // roadmap item category
                                        let roadmapItem = roadmapState.cards.find(ri => ri._id === c.roadmapItem);
                                        if (project && roadmapItem) {
                                            let roadmapItemLabel = roadmapState.categories.find(rc => rc._id === roadmapItem!.categoryId);
                                            if (roadmapItemLabel) {
                                                label = {
                                                    _id: "",
                                                    projectId: project._id,
                                                    title: roadmapItem.title,
                                                    backgroundColor: roadmapItemLabel.backgroundColor,
                                                    fontColor: roadmapItemLabel.fontColor,
                                                    created: new Date(),
                                                    modified: new Date(),
                                                    active: true,
                                                }
                                            } else {
                                                /* uncategorized roadmap item */
                                                label = {
                                                    _id: "",
                                                    projectId: project._id,
                                                    title: roadmapItem.title,
                                                    backgroundColor: "#efefef",
                                                    fontColor: "#000",
                                                    created: new Date(),
                                                    modified: new Date(),
                                                    active: true,
                                                }
                                            }
                                        }
                                    } else {
                                        label = projectState.labels.find(l => l._id === lc.labelId);
                                    }
                                    let style = {
                                        backgroundColor: label?.backgroundColor,
                                        color: label?.fontColor
                                    }

                                    let title = "";
                                    if (label) {
                                        title = label.title;
                                        if (title.length >= 30) {
                                           title = title.substring(0,27) + "...";
                                        }
                                    }
                                    if (label) {
                                        return (
                                        <div key={"mh-"+lc._id} className="labelBadgeSmall mb-1" style={style} onClick={(e) => handleHideLabelText(e)}>
                                            {!hideLabelText &&
                                                <>
                                                {label?.title === "" ?
                                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                :
                                                    <span>{title}</span>
                                                }
                                                </>
                                            }
                                        </div>
                                        );
                                    }
                                })}
                                {labelsToCards.length > 0 &&
                                    <div style={{clear: "both"}}></div>
                                }
                                <div style={{ lineHeight:1.3, whiteSpace: "normal" }}>
                                    {c.title}
                                </div>
                                {c.ticketId > 0 &&
                                    <div className="cfTicket">
                                        {/*
                                        <div style={{ display: "inline-block", paddingTop: "5px" }}>
                                            <FaUserCircle size="18" />
                                        </div>
                                        */}
                                        {c.ownerId !== "" ?
                                            <Avatar size="xxsmall" member={cardOwner} inline={true} />
                                        :
                                            <div style={{ display: "inline-block", paddingTop: "5px" }}>
                                                <FaUserCircle size="18" />
                                            </div>
                                        }
                                        
                                        <span style={{paddingRight: "3px" }}>&nbsp;</span>
                                        <span>
                                            {format(new Date(c.created),"eee L/d").toUpperCase()}
                                            &nbsp;
                                            H{c.ticketId}
                                            &nbsp;
                                            {c.status}
                                        </span>
                                    </div>
                                }
                                {project?.permission?.toString() !== "observer" &&
                                    <div style={{ float: "right", position: "relative", top: "-20px", right: "-16px" }}
                                        onClick={(e) => toggleWatch(e, c._id)}>
                                        <GiStopwatch size={18} color={stopwatchColor} />
                                    </div>
                                }
                            </div>
                        </div>
                    )}
                </Draggable>
            );
        });
        // 2 6 2 2 default
        /*
        let cCenterLeft = "";
        let cRight = "";

        let cLeft = (index !== 0) ? "col-2" : "";

        if (index === 0 && index === projectState.lists.length - 1) {
            cCenterLeft = "col-9";
        } else if (index !== 0 && index !== projectState.lists.length - 1) {
            cCenterLeft = "ps-0 col-6";
        } else if (index === 0) {
            cCenterLeft = "col-8";
        } else if (index === projectState.lists.length - 1) {
            cCenterLeft = "p-0 col-7";
        }
        
        if (index === 0 && index === projectState.lists.length - 1) {
            cRight = "col-3";
        }else if (index === projectState.lists.length - 1) {
            cRight = "col-1";
        } else if (index === 0) {
            cRight = "col-4";
        } else {
            cRight = "col-4";
        }
        */

        let listClass = (minimized) ? "listBackgroundMinimized" : "listBackground";
        let cardPlaceholderClass = (minimized) ? "cardPlaceholderMinimized" : "cardPlaceholder";

        let cardPlaceholderMinimizeStyle: CSSProperties = {
            writingMode: "vertical-rl",
            textOrientation: "mixed",
        }

        let cardPlaceholderStyle = (minimized) ? cardPlaceholderMinimizeStyle : {};

        let listsStatusPillColor = "";
        let listsStatusPillBackgroundColor = "";
        if (list.status === "Open") {
            listsStatusPillColor = "#fff";
            listsStatusPillBackgroundColor = "#2e86c1";
        } else if (list.status === "In Progress") {
            listsStatusPillColor = "#fff";
            listsStatusPillBackgroundColor = "#e67e22";
        } else if (list.status === "Paused") {
            listsStatusPillColor = "#000";
            listsStatusPillBackgroundColor = "#f4d03f";
        } else if (list.status === "Done") {
            listsStatusPillColor = "#fff";
            listsStatusPillBackgroundColor = "#138d75";
        } else if (list.status === "Canceled") {
            listsStatusPillColor = "#fff";
            listsStatusPillBackgroundColor = "#2e4053";
        } else if (list.status === "Strategy") {
            listsStatusPillColor = "#fff";
            listsStatusPillBackgroundColor = "#9b59b6";
        }

        let listStatusPillStyle: CSSProperties = {
            backgroundColor: listsStatusPillBackgroundColor,
            opacity: .4,
            borderRadius: "30px",
            padding: "2px",
            //width: "92%",
            width: "100%",
            margin: "5px auto 0px auto",
            height: "4px",
            ...(project?.permission?.toString() !== "observer") && { cursor: "pointer" },
            //margin: "0px auto"
        }

        const { totalEstimated, totalActual } = cards.reduce(
            (acc, card) => {
              acc.totalEstimated += card.estimatedWork || 0;
              acc.totalActual += card.actualWork || 0;
              return acc;
            },
            { totalEstimated: 0, totalActual: 0 }
          );
    
        let percentDone = totalEstimated > 0 
            ? (totalActual / totalEstimated) * 100 
            : 0;

            /*
        percentDone = (percentDone > 100) ? 92 : percentDone / 100 * .92 * 100;

        if (list.status === "Done") {
            percentDone = 92;
        }
            */
        percentDone = (percentDone > 100) ? 100 : percentDone;

        if (list.status === "Done") {
            percentDone = 100;
        }

//console.log(percentDone);
        let listStatusPillOverlayStyle: CSSProperties = {
            backgroundColor: listsStatusPillBackgroundColor,
            opacity: 1,
            borderRadius: "30px",
            padding: "2px",
            width: percentDone + "%",
            height: "4px",
            position: "relative",
            top: "-4px",
            marginBottom: "-4px",
            //left: "4%",
            ...(project?.permission?.toString() !== "observer") && { cursor: "pointer" },
            //margin: "0px auto"
        }

        let listNameMinimizedStyle: CSSProperties = {
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            marginLeft: "-6px",
            //marginLeft: "7px",
            //marginLeft: "4px",
            color: "gray",
            marginTop: "5px",
            fontWeight: "normal"
        }
        let listNameStyle = (minimized) ? listNameMinimizedStyle : {};

        return (
            <div style={{ display: "inline-block" }} key={"listcontainer-" + index}>
            {index === 0 && 
                <>
                    {showAddListField[index] && !isObserver &&
                        <input type="text" className="newList ms-3" placeholder="+ add list"
                            value={newList}
                            onChange={(e) => handleNewListChange(e)} 
                            onKeyDown={(e) => createNewList(e, index)}
                            style={{ marginRight: "0px" }}
                        />
                    }
                    {!isObserver ?
                        <div className="listAddButton">
                            <span>
                                <Link to="" onClick={e => toggleAddListField(e, index)}>
                                    <FaEllipsisV color="#efefef" size="20" />
                                </Link>
                            </span>
                        </div>
                    :
                        <div className="listAddButton" style={{ width: "16px" }}></div>
                    }
                </>
            }
            {/* style={listStyle} */}

            <div className={listClass} key={"list-" + index}>
                {!listNamesInEditMode[index] ?
                <>
                    {!minimized &&
                        <div className="text-wrap" style={{ 
                            margin: "0 -7px",
                            fontSize: "12pt",
                            position: "relative",
                            top: "-7px",
                            fontWeight: 650,
                            backgroundColor: "rgb(226, 226, 227)",
                            padding: "4px 15px",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            color: "#000",
                            boxSizing: "border-box"
                         }}
                            onClick={(project?.permission?.toString() !== "observer") ? () => toggleEditListName(index) : undefined }
                            >
                            <div>{listNames[index]}</div>
                            <div style={listStatusPillStyle} onClick={
                                (project?.permission?.toString() !== "observer") ? 
                                    (e) => handleShowChangeListStatus(e, list._id)
                                : 
                                    undefined
                                }>
                            </div>
                            {percentDone > 0 &&
                                <div style={listStatusPillOverlayStyle} onClick={
                                    (project?.permission?.toString() !== "observer") ? 
                                        (e) => handleShowChangeListStatus(e, list._id)
                                    : 
                                        undefined
                                    }>
                                </div>
                            }
                        </div>
                    }
{/* className={cLeft} in empty div under !list.minimized */}
                    <div style={{ margin: "0px auto", textAlign: "center", ...(!minimized && { height: "26px" }) }}>
                        {!minimized &&
                        <>
                            {index > 0 && project?.permission?.toString() !== "observer" &&
                                <div className="listIcon" style={{ display: "inline-block", marginRight: "5px" }}>
                                    <Link to="" onClick={(e) => {
                                        e.preventDefault();
                                        moveList(list._id, -1)}
                                    }>
                                        <span style={{ position: "relative", top: "-4px" }}>
                                            <MdKeyboardArrowLeft size="18" color="#737373" />
                                        </span>
                                    </Link>
                                </div>
                            }
                        </>
                        }
                        {minimized &&
                        <>
                            <div style={{ marginLeft: "-2px" }}>
                                <Link to="" onClick={(e) => handleMinimizeList(e, list._id, minimized ? false: true )}>
                                    <FiMinimize2 color="gray" />
                                </Link>
                            </div>
                            <div className="text-wrap" style={listNameStyle}>
                                {listNames[index]}
                            </div>
                            <div style={{ ...listStatusPillStyle, opacity: 1, marginTop: "10px" }}>
                            </div>
                        </>
                        }
                        {/*
                        {project?.permission?.toString() !== "observer" && !list.minimized ?
                            <div className={`${cCenterLeft} text-wrap`} onClick={() => toggleEditListName(index)} style={listNameStyle}>
                                {listNames[index]}
                            </div>
                        :
                            <div className="col-12 text-wrap" style={listNameStyle}>
                                {listNames[index]}
                            </div>
                        }
                        
                        <div className={cRight}> below in empty div
                        */}
                        {!minimized &&
                            <> 
                                <div className="listIcon" style={{ display: "inline-block", marginRight: "5px" }}>
                                    <Link to="" onClick={(e) => handleMinimizeList(e, list._id, minimized ? false: true )} style={{ marginRight: "10px" }}>
                                        <span style={{ position: "relative", top: "-4px", left: "5px" }}>
                                            <FiMinimize2 size="10" color="#737373" />
                                        </span>
                                    </Link>
                                </div>
                                {project?.permission?.toString() !== "observer" &&
                                <>
                                    <div className="listIcon" style={{ display: "inline-block", marginRight: "5px" }}
                                        onClick={e => handleCopyList(e, list)}>
                                        <span style={{ position: "relative", top: "-4px", left: "1px" }}>
                                            <FaCopy size="10" color="#737373" />
                                        </span>
                                    </div>
                                    <div className="listIcon" style={{ display: "inline-block", marginRight: "5px" }}>
                                        <Link to="" onClick={(e) => handleDeleteList(e, list._id)}>
                                        {/*<Link to="" onClick={(e) => toggleListContextMenu(e, list._id)}>*/}
                                            {/*<BsThreeDots />*/}
                                            <span style={{ position: "relative", top: "-4px", left: "0px" }}>
                                                <IoTrashOutline size="12" color="#737373" />
                                            </span>
                                        </Link>
                                    </div>
                                </>

                                }
                                {index < projectState.lists.length - 1 && project?.permission?.toString() !== "observer" &&
                                    <div className="listIcon" style={{ display: "inline-block", marginRight: "5px" }}>
                                        <Link to="" onClick={(e) => { e.preventDefault(); moveList(list._id, 1)}}>
                                            <span style={{ position: "relative", top: "-4px" }}>
                                                <MdKeyboardArrowRight size="18" color="#737373" />
                                            </span>
                                        </Link>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </>
                :
                    <div key={"list-" + index}>
                        <input className="changeListName" type="text"
                            value={listNames[index]}
                            autoFocus
                            onChange={(e) => handleListNameChange(e, index)} 
                            onKeyDown={(e) => updateListName(e, index, list._id)}
                            onBlur={(e) => updateListNameOnBlur(e, index, list._id)}
                        />             
                    </div>
                }

                {/*
                <div style={listStatusPillStyle} onClick={
                    (project?.permission?.toString() !== "observer") ? 
                        (e) => handleShowChangeListStatus(e, list._id)
                    : 
                        undefined
                    }>
                </div>
                {percentDone > 0 &&
                    <div style={listStatusPillOverlayStyle} onClick={
                        (project?.permission?.toString() !== "observer") ? 
                            (e) => handleShowChangeListStatus(e, list._id)
                        : 
                            undefined
                        }>
                    </div>
                }
                */}

                <Droppable droppableId={(list._id) ? list._id.toString() : ""}>
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {formattedCards}
                            {formattedCards.length === 0 && projectCardCount > 0 &&
                                <div className={cardPlaceholderClass} style={cardPlaceholderStyle}>
                                    {placeholderDropText}
                                </div>
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                {!minimized && project?.permission?.toString() !== "observer" &&
                    <div>
                        <input className="addCard" type="text" placeholder="+ add card"
                            value={(newCardTitles[index]) ? newCardTitles[index] : ""}
                            onChange={(e) => handleNewCardTitleChange(e, index)} 
                            onKeyDown={(e) => createNewCard(e, index, list._id)}
                            onBlur={(e) => createNewCard(e, index, list._id)}
                        />
                    </div>
                }
                {/*
               {projectState.searchText === "" && !list.minimized &&
                <div>
                    <input className="addCard" type="text" placeholder="+ add card"
                        value={(newCardTitles[index]) ? newCardTitles[index] : ""}
                        onChange={(e) => handleNewCardTitleChange(e, index)} 
                        onKeyDown={(e) => createNewCard(e, index, list.id)}
                        onBlur={(e) => createNewCard(e, index, list.id)}
                    />
                </div>
                }
                */}
            </div>
            <>
                {project?.permission?.toString() !== "observer" ?
                    <div className="listAddButton">
                        <span>
                            <Link to="" onClick={e => toggleAddListField(e, index + 1)}>
                                <FaEllipsisV color="#efefef" size="20" />
                            </Link>
                        </span>
                    </div>
                :
                    <div className="listAddButton" style={{ width: "20px" }}></div>
                }
                {showAddListField[index+1] && !isObserver &&
                    <input type="text" className="newList" placeholder="+ add list"
                        value={newList}
                        onChange={(e) => handleNewListChange(e)} 
                        onKeyDown={(e) => createNewList(e, index + 1)}
                    />
                }
            </>
        </div>
        )
    });

    return (
        <div className="rightContentDefault" style={{ padding: "13px 0px"}}>
            {!projectState.projectSwitchingStatus &&
                <div className="listBody">
                    <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                        {lists}
                    </DragDropContext>
                    {lists.length === 0 && !isObserver &&
                        <input type="text" className="newList ms-3" placeholder="+ add list"
                            value={newList}
                            onChange={(e) => handleNewListChange(e)} 
                            onKeyDown={(e) => createNewList(e, 0)}
                        />
                    }
                </div>
            }
            <ChangeListStatusContextMenu params={changeListContextMenuParams} />
            <PopupContextMenu params={popupParams} />
            <ListContextMenu params={listContextMenuParams} />
            <CardContextMenu params={cardContextParams} />
            <LabelContextMenu params={labelContextMenuParams} />
        </div>
    );
}

export default WorkBoard;